import {Component, OnInit} from '@angular/core';
import {DataManagementService} from '../services/data-management.service';

@Component({
    selector: 'app-utility',
    templateUrl: './utility.component.html',
    styleUrls: ['./utility.component.css'],
    providers: [DataManagementService]
})
export class UtilityComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
